import React from 'react';
import PropTypes from 'prop-types';
import csrfToken from './csrf';
import style from './IdCardPrinterBoard.module.sass';

// Mirrors PrinterChip's RemoveForm: a real HTML form so it works with no JS
// beyond what already rendered the card, guarded by a plain onClick confirm
// rather than data-confirm (rails-ujs isn't loaded).
const RemoveForm = ({ removeUrl, disabled }) => (
  <form action={removeUrl} method="post" className={style.removeForm}>
    <input type="hidden" name="_method" value="delete" />
    <input type="hidden" name="authenticity_token" value={csrfToken()} />
    <button
      type="submit"
      className="btn btn-link btn-sm"
      disabled={disabled}
      onClick={(event) => {
        // eslint-disable-next-line no-alert
        if (!window.confirm('Remove this printer for good? This cannot be undone.')) event.preventDefault();
      }}
    >
      Remove
    </button>
  </form>
);

RemoveForm.propTypes = {
  removeUrl: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

const RetiredPrinterCard = ({ printer, disabled, onRestore }) => (
  <div className={`${style.card} ${style.cardBarGray}`}>
    <div className={style.cardSchool}>{printer.model || 'Unknown model'}</div>
    <div className={style.printerChipHeadline}>
      {printer.serial_number && <span>{`Serial # ${printer.serial_number}`}</span>}
    </div>

    {printer.notes && <div className={style.cardNotes}>{printer.notes}</div>}
    {printer.troubleshooting_notes && (
      <div className={style.cardNotes}>
        <strong>Troubleshooting:</strong>
        {` ${printer.troubleshooting_notes}`}
      </div>
    )}

    <div className={style.cardActions}>
      <a href={printer.edit_url}>Edit</a>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        disabled={disabled}
        onClick={() => onRestore(printer)}
      >
        Restore to Inventory
      </button>
      <RemoveForm removeUrl={printer.remove_url} disabled={disabled} />
    </div>
  </div>
);

RetiredPrinterCard.propTypes = {
  printer: PropTypes.shape({
    serial_number: PropTypes.string,
    model: PropTypes.string,
    notes: PropTypes.string,
    troubleshooting_notes: PropTypes.string,
    edit_url: PropTypes.string.isRequired,
    remove_url: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
  onRestore: PropTypes.func.isRequired,
};

export default RetiredPrinterCard;
